import * as slices from 'store/slice';
import { configureStore, Store } from '@reduxjs/toolkit';
import { activitiesApi } from 'store/api/activitiesApi';
import { RootState } from 'store/store.types';

let store: Store<RootState>;
const getStore = (preloadedState?: RootState, forceInitialize = false) => {
    if (!store || forceInitialize) {
        store = configureStore({
            preloadedState,
            // Please keep variables sorted
            reducer: {
                api: activitiesApi.reducer,
                availability: slices.availability,
                bootstrap: slices.bootstrap,
                detailCalendar: slices.detailCalendar,
                details: slices.details,
                review: slices.review,
                error: slices.error,
                home: slices.home,
                menu: slices.menu,
                navigation: slices.navigation,
                overlay: slices.overlay,
                screen: slices.screen,
                search: slices.search,
                notification: slices.notification,
            },
            // @ts-ignore
            middleware: (getDefaultMiddleware) =>
                getDefaultMiddleware({
                    serializableCheck: false, // Do not warn about non serializable values in state, eg. functions.
                }).concat(activitiesApi.middleware),
        });
    }

    return store;
};

/**
 * <b>ALERT!</b>
 * This method should be used only for global mappers where we can not access the state using hooks.
 */
export const getStoreState = (): RootState => getStore().getState();

export default getStore;
